import { render, staticRenderFns } from "./UserListView.vue?vue&type=template&id=b6a00ce8&"
import script from "./UserListView.vue?vue&type=script&lang=js&"
export * from "./UserListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports